import React from "react";
import styles from "./Components.module.scss";
import { NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";
import { Label, Error } from "@progress/kendo-react-labels";
import { useCompany } from "services/companyService";

const ConsultantSettings = ({ data = {}, onChange, mode, errors = {} }) => {
  const READ_ONLY = mode === "view";
  const { data: company } = useCompany();
  const modules = company?.modules || {};
  const isConsultantModuleEnabled = Boolean(modules?.Consultants);

  const handleFieldChange = (field, value) => {
    if (field === "commissionPercentage") {
      value = value || 0;
    }
    onChange(field, value);
  };

  if (!isConsultantModuleEnabled) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Consultant Settings</h2>
        <p>Consultant module is not enabled for this company.</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Consultant Settings</h2>

      <div className={styles.formGrid}>
        <div className={styles.formRow}>
          <div className="d-flex flex-column gap-2">
            <Checkbox
              checked={!!data.isConsultant}
              onChange={(e) => handleFieldChange("isConsultant", e.value)}
              disabled={READ_ONLY}
              label="Is Consultant"
            />
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formField}>
            <Label>Commission Percentage</Label>
            <NumericTextBox
              value={data.commissionPercentage ?? null}
              onChange={(e) =>
                handleFieldChange("commissionPercentage", e.value)
              }
              className={styles.rightAlignNumber}
              format="n2"
              spinners={false}
              placeholder="0.00"
              disabled={READ_ONLY}
            />
            {errors.commissionPercentage && (
              <Error>{errors.commissionPercentage}</Error>
            )}
          </div>
        </div>

        <hr className={styles.horizontalLine} />

        <div className={styles.formRow}>
          <div className="d-flex flex-column gap-2">
            <Checkbox
              checked={!!data.isConsultantVATIncluded}
              onChange={(e) =>
                handleFieldChange("isConsultantVATIncluded", e.value)
              }
              disabled={READ_ONLY}
              label="Include VAT in commission"
            />
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formField}>
            <Label>VAT Number</Label>
            <NumericTextBox
              value={data.consultantVATNumber ?? null}
              onChange={(e) =>
                handleFieldChange("consultantVATNumber", e.value)
              }
              className={styles.rightAlignNumber}
              format="n2"
              spinners={false}
              placeholder="0.00"
              disabled={READ_ONLY}
            />
            {errors.consultantVATNumber && (
              <Error>{errors.consultantVATNumber}</Error>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultantSettings;
